import { HttpClient } from '@angular/common/http';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import {
    AppSettingsService,
    DataFormattingService,
    DiscovererQueryService,
    IColumnSetting,
    IDRFilter,
    TabSettingsService,
} from '@app/discoverer/core';
import { from, Subject, Subscription } from 'rxjs';
import { TableConfigVM } from '@app/shared-components/chart.interfaces';
import { FilterCreationService } from '../filter-creation-service';

@Component({
    selector: 'home-page-table',
    templateUrl: './home-table.component.html',
    styleUrls: ['./home-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicTableComponent implements OnInit, OnDestroy {
    public isTableLoading = false;

    @Output() tableSelected = new EventEmitter<string>();
    @Input() set extraFilters(v: Record<string, any>) {
        this._extraFilters = v || {};
        this.applyFiltersForSelected();
    }

    @Input() tableOptionMenu: TableConfigVM[] = [];
    @Input() hideMenu = false
    @Input() set defaultRequest(v: string | undefined) {
        const requestIndex = this.tableOptionMenu.findIndex(x => x.requestId == v);
        if (requestIndex != -1) {
            const v = this.tableOptionMenu[requestIndex];
            this.selectRequest(v);
        }
    }
    public selectedRequest: TableConfigVM | undefined;
    public tabContext;

    private?: Subscription;

    private _extraFilters: Record<string, any> = {};
    private currentTabCols: IColumnSetting[] = [];

    constructor(
        public formattingService: DataFormattingService,
        private filterCreationService: FilterCreationService

    ) { }

    ngOnInit() {


    }

    ngOnDestroy(): void {
    }

    selectRequest(option: TableConfigVM) {
        this.selectedRequest = option;
        if (this.selectedRequest.queryService)
            this.applyFiltersForSelected();
        this.tableSelected.emit(option.requestId);
    }
    setTabContext(context): void {
        this.tabContext = context;
        if (this.tabContext)
            this.currentTabCols = context.columnSettings;
        this.selectedRequest.queryService = new DiscovererQueryService('table' + this.selectedRequest.requestId)
        this.applyFiltersForSelected();

    }

    private applyFiltersForSelected() {
        if (!this.selectedRequest) return;
        const filters = this._extraFilters || {};

        for (const [field, value] of Object.entries(filters)) {
            if (value === undefined || value === null || value === '') continue;

            const mappedField =
                this.selectedRequest.filterMap?.[field] ?? field;
            const filter = this.filterCreationService.createFilter(mappedField, value, this.currentTabCols);
            this.selectedRequest.queryService.setFilter(mappedField, filter);
            this.selectedRequest.queryService.refresh();
        }


    }



}
